import {
  FaRegFileArchive,
  FaRegFileImage,
  FaRegFileCode,
  FaRegFile,
  IconBaseProps,
} from '@bymason-private/legacy-pattern-components';
import { ArtifactType } from '@bymason/controller-api-hooks';

export function ArtifactTypeIcon({ type, ...iconProps }: ArtifactTypeIconProps) {
  switch (type) {
    case ArtifactType.Apk:
      return <FaRegFileArchive title={type} {...iconProps} />;
    case ArtifactType.Config:
      return <FaRegFileCode title={type} {...iconProps} />;
    case ArtifactType.Media:
      return <FaRegFileImage title={type} {...iconProps} />;
    default:
      return <FaRegFile title={type} {...iconProps} />;
  }
}

export interface ArtifactTypeIconProps extends IconBaseProps {
  type: ArtifactType;
}
